<template>
    <div>
        <div class="">
            <div class="">
                <div class="px-4 sm:px-0">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">Set up the layout and colors</h3>
                </div>
            </div>
            <div class="mt-4">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md">
                        <div class="md:grid grid-cols-1 md:grid-cols-2 md:gap-6 px-4 py-5 bg-white sm:p-6">
                            <div class="col-span-1">
                                <InputSelectColor v-model="form.body.backgroundColor"
                                                  label="Body background color"
                                                  :palette="palette" :selected="form.body.backgroundColor"/>
                            </div>
                            <div class="col-span-1">
                                <InputSelectColor v-model="form.body.linkColor" label="Link color"
                                                  :palette="palette" :selected="form.body.linkColor"/>
                            </div>
                            <!-- NAV -->
                            <div class="col-span-1">
                                <InputSelectColor v-model="form.navigation.backgroundColor"
                                                  label="Navigation background color"
                                                  :palette="palette"
                                                  :selected="form.navigation.backgroundColor"/>
                            </div>
                            <div class="col-span-1">
                                <InputSelectColor v-model="form.primaryButton.backgroundColor"
                                                  label="Primary button background color"
                                                  :palette="palette"
                                                  :selected="form.primaryButton.backgroundColor"/>
                            </div>

                            <div class="flex items-start">
                                <div class="flex items-center h-5">
                                    <input id="logo.shadow" type="checkbox" v-model="form.logo.shadow"
                                           class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">
                                </div>
                                <div class="ml-3 text-sm leading-5">
                                    <label for="logo.shadow" class="font-medium text-gray-700">Drop shadow on
                                        the
                                        logo</label>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="flex items-center h-5">
                                    <input id="logo.footer" type="checkbox" v-model="form.logo.footer"
                                           class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">
                                </div>
                                <div class="ml-3 text-sm leading-5">
                                    <label for="logo.footer" class="font-medium text-gray-700">Show logo in the footer</label>
                                </div>
                            </div>

                        </div>

                        <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <ActionMessage :on="form.recentlySuccessful" class="mr-3">
                                Saved.
                            </ActionMessage>

                            <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                Save
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import InputSelectColor from "./InputSelectColor";
    import Button from "@/Jetstream/Button";
    import ActionMessage from "@/Jetstream/ActionMessage";
    import EventBus from "@/Jobroll/EventBus";

    export default {
        name: "EditBasic",
        components: {
            InputSelectColor,
            ActionMessage,
            Button
        },
        props: {
            colors: Object,
            palette: Array,
            board: Object,
            errors: Object
        },
        data() {
            return {
                form: {
                    body: {
                        backgroundColor: this.colors?.body?.backgroundColor || 'green-50',
                        linkColor: this.colors?.body?.linkColor || 'green-600'
                    },
                    navigation: {
                        backgroundColor: this.colors?.navigation?.backgroundColor || 'green-300',
                    },
                    primaryButton: {
                        backgroundColor: this.colors?.primaryButton?.backgroundColor || 'indigo-600'
                    },
                    logo: {
                        shadow: this.colors?.logo?.shadow,
                        footer: this.colors?.logo?.footer
                    },
                    footer: {
                        backgroundColor: this.colors?.footer?.backgroundColor || 'gray-700',
                        textColor: this.colors?.footer?.textColor || 'gray-400'
                    }
                },
            }
        },
        watch: {
            form: {
                handler(val) {
                    EventBus.$emit('theme-updated', val)
                },
                deep: true
            }
        },
        methods: {
            submit() {
                const form = this.$inertia.form(this.form, {
                    resetOnSuccess: false
                });

                form.post('/design', {preserveScroll: true})
            }
        },
    }
</script>
